module.exports = __webpack_public_path__ + "static/media/Extruded tooth14.3745b98e.png";